import type { OrganizationMember } from '@kirin/api-client/contracts/organization-members';

type MemberKindFields = Pick<OrganizationMember, 'userType' | 'offboardedAt'>;

/**
 * A row that is a real account of the organization: a full user who is not
 * offboarded (KIR-3908 Discovered/Unattributed rows and KIR-5410 Offboarded
 * rows are not). Seats, roles, invites and duplicate checks use this.
 */
export function isAccountMember(member: MemberKindFields): boolean {
  return (
    (!member.userType || member.userType === 'full') && !member.offboardedAt
  );
}

/**
 * KIR-5410: who a security group can take. Every current account; with shared
 * devices on, also people without a Descope account (Discovered / Unattributed,
 * added by internal id). Never an offboarded person.
 */
export function canJoinSecurityGroup(
  member: MemberKindFields,
  sharedDevicesEnabled: boolean
): boolean {
  if (member.offboardedAt) return false;
  return isAccountMember(member) || sharedDevicesEnabled;
}

/**
 * KIR-5410: who the Shadow AI organization average divides by — the people the
 * backend's Shadow AI scope covers. Current accounts; with shared devices on,
 * also Discovered / Unattributed people. Never an offboarded person.
 */
export function isShadowAiScopePerson(
  member: MemberKindFields,
  sharedDevicesEnabled: boolean
): boolean {
  if (member.offboardedAt) return false;
  return isAccountMember(member) || sharedDevicesEnabled;
}
